import { Nurse, Aide, Volunteer, SocialWorker, Spiritual } from './roleData'; // This is from widgetconfig.json in dashboard
// API/Database.ts

export const COUCHDB_POLL_INTERVAL = 60000; // HTTP Status Codes:

export const HTTP_STATUS_OK = 200; // ClearScripts Server API Constants

export const MAINT_STATUS_COMPLETE = 'complete';
export const MAINT_STATUS_PENDING = 'pending';
export const MAINT_ORDER_TYPE_VERBAL = 'verbal';
export const MAINT_ORDER_TYPE_ADMIT = 'admit';
export const CLEARSCRIPTS_CLIENT = 'clearscripts-client';
export const MED_ORDER_TYPE_START = 'start';
export const MED_ORDER_TYPE_STOP = 'stop';
export const MED_IS_CURRENT_VERSION_TRUE = 'y';
export const MED_IS_CURRENT_VERSION_FALSE = 'n';
export const MED_IS_RCOPIA_DELETED_TRUE = 'y';
export const MED_IS_RCOPIA_DELETED_FALSE = 'n';
export const RCOPIA_STOPREASON_DELETED = 'deleted';
export const MED_SERIES_START_INDEX = '0';
export const SYNC_MEDS_TIME_INTERVAL = 30;
export const SYNC_MEDS_INTERVAL_MINUTES = 'minutes'; // Cert-app

export const Certification = 'Certification'; // ClearScripts Printing

export const AllMedications = 'All';
export const ActiveMedications = 'Active';
export const ActiveAndMaintainedMeds = 'Active with Mods'; // DocLink Printing

export const Card = 'Card';
export const Listing = 'Listing'; // Manifest Printing

export const Contents = 'Contents';
export const TabularView = 'Tabular'; // Option to print Notes

export const Notes = 'Notes';
export const Orders = 'Orders';
export const GeneralNotes = 'General Notes'; // Print

export const print = 'print'; // IDG

export const idg = 'idg';
export const uppercaseIdg = 'IDG'; // READ ONLY

export const readonly = 'readonly'; // Widget Names

export const Bereavement = 'Bereavement';
export const CarePlanFrequency = 'CarePlanFrequency';
export const CarePlanProblems = 'CarePlanProblems';
export const CompletedForms = 'CompletedForms';
export const ClearScripts = 'ClearScripts';
export const DocLink = 'DocLink';
export const Facesheet = 'Facesheet';
export const Forms = 'Forms';
export const HospiceItemSet = 'HospiceItemSet';
export const IDGDocument = 'IDGDocument';
export const Manifest = 'Manifest';
export const Measures = 'Measures';
export const PatientsListing = 'PatientsListing';
export const PatientAssistance = 'PatientAssistance';
export const ProgressNotes = 'ProgressNotes';
export const ComplianceView = 'ComplianceView';
export const ComplianceCrossPatient = 'ComplianceCrossPatient';
export const VisitLog = 'VisitLog';
export const FaxLog = 'FaxLog';
export const VisitSummary = 'VisitSummary';
export const Hope = 'Hope';
export const Questionnaires = 'Questionnaires';
export const Incidents = 'Incidents';
export const MAIAChatAgent = 'MAIAChatAgent';
export const Tasks = 'Tasks';
export const Progress_Notes = 'Progress Notes';
export const Care_Plan_Problems = 'Care Plan Problems';
export const FacetoFaceEncounter = 'Face to Face Encounter';
export const HCPCS_Billable = 'Billable HCPCS';
export const HopeAttribute = 'HOPE attribute'; // Care Plan Problems, Forms, Completed Forms

export const NONE = 'NONE';
export const ANSWERED = 'ANSWERED';
export const ALL = 'ALL'; // Care Plan Problems and Forms

export const Submitted = 'Submitted';
export const InProgress = 'In Progress';
export const InProgressDriving = 'In Progress Driving';
export const DRIVING_VISIT_MAX_MINUTES = 120;
export const Autosave = 'Autosave';
export const Discard = 'Discard';
export const Created = 'Created';
export const Edit = 'Edit';
export const Delete = 'Delete';
export const Resolve = 'Resolve';
export const View = 'View';
export const Print = 'Print';
export const ReopenVisit = 'Reopen';
export const DocumentVisit = 'Document'; // Forms

export const FAJITA = 'FAJITA';
export const FORMIO = 'FORMIO';
export const IDGDATA = 'IDGDATA';
export const IDGPDF = 'IDGPDF';
export const C2 = 'C2';
export const CLINICAL = 'clinical'; // Task

export const ACTIVE = 'Active';
export const DISCONTINUED = 'Discontinued';
export const PENDING = 'Pending'; // Permissions

export const ROLE_HOSPICE_ADMIN = 'ROLE_HOSPICE_ADMIN';
export const ROLE_ADMIN = 'ROLE_ADMIN'; // Printing Notes manifest

export const IDG_MEETING_REVIEW = 'IDG MEETING REVIEW';
/** patientmanifests `status` query — non-FAJITA rows (Manifest widget, print Manifest block) */

export const patientManifestStatusNonHz = 'nonhz'; // Attending Physician

export const ATTENDING_PHYSICIAN = 'ATTENDING_PHYSICIAN'; // Geolocation

export const GEOLOCATION_PERMISSION_DENIED = 1; // Tasks

export const includedc = 'true'; // Misc.

export const STRING_TRUE = 'true';
export const STRING_FALSE = 'false'; // QCodes

export const Q5001 = 'Q5001';
export const Q5006 = 'Q5006';
export const Q5010 = 'Q5010';
export const GIPQCODES = [Q5006, Q5010]; // LOC

export const DIRECT_CARE = 'DIRECT_CARE'; // Progress Notes Printing & ReactPDF

export const Both = 'Both';
export const emptyNoteText = ' ';
export const emptyText = '';
export const OnePerPage = 'One per page';
export const MultiPerPage = 'Multi per page'; // Dashboard & Progress Notes

export const PRNRoles = [{
  name: Nurse,
  key: 'prnnurse'
}, {
  name: SocialWorker,
  key: 'prnsocialworker'
}, {
  name: Spiritual,
  key: 'prnspiritual'
}, {
  name: Aide,
  key: 'prnaide'
}, {
  name: Volunteer,
  key: 'prnvol'
}]; // Facility and Standing Orders

export const PSO = 'PSO';
export const PSOHome = 'PSO-H';
export const PSOFacility = 'PSO-F'; // get Physician

export const cert = 'cert'; // Measures ReactPDF

export const Graphs = 'Graphs';
export const Listings = 'Listings';
export const scores = 'scores';
export const esas = 'esas'; // Task

export const week = 'week'; // IDG + Dashboard + Forms

export const LCD_NGS = 'LCD-NGS';
export const LCD_PGBA = 'LCD-PGBA';
export const idgLcdString = 'idg-lcd';
export const idgPgbaString = 'idg-pgba';
export const lowercaseT = 't';
export const ComprehensiveAssessment = 'Comprehensive Assessment'; // ReactPDF

export const ReactPDFString = 'ReactPDF'; // API status

export const info = 'info';
export const error = 'error';
export const success = 'success';
export const warning = 'warning'; // programSiteName

export const Hospice = 'Hospice';
export const PalliativeCare = 'Palliative Care';
/**
HP   | Hospice
PD   | Private Duty
PC   | Palliative Care
NE   | Non-enrolled Hospice
CM   | Medicare Care Choice Model
CB   | Community Bereavement
HH   | Home Health
LT   | Long Term Referral
PM   | Palliative Management
*/
// Suggest Box

export const emptyOption = {
  id: '',
  label: '',
  value: ''
}; // Visits

export const SmartChart = 'SMARTCHART';
export const SmartChartIPU = 'SMARTCHART_IPU'; // Order Type

export const CPF = 'CPF';
export const ADM = 'ADM';
export const MMD = 'MMD';
export const PCPPT = 'PCPPT';
export const MFST = 'MFST';
export const PCPF = 'PCPF';
export const PCPP = 'PCPPv2';
export const MEAS = 'MEAS';
/** Election Addendum progress-note entity (pending key is typically '-1') */

export const EA = 'EA';
/**
 * Workflow EA trigger `source` when the trigger is a progress note
 * (see workflow.addelectionaddendumtrigger docs).
 */

export const EA_TRIGGER_SOURCE_PROGRESS_NOTE = 'observation.patientprogressnote.id';
/**
 * Trigger type for Note for EA. Workflow closed set: paysource | poc | reset.
 */

export const EA_NOTE_TRIGGER_TYPE = 'poc';
export const cppEditingAllowedRoleGroup = ['Administration', 'Bereavement', 'Care Coordinator (MCCM)', 'Dietary', 'DMS', 'Doctor', 'Doula', 'Executive', 'Family Counseling', 'Finance', 'HIS', 'IDG Team Roles', 'Massage Therapist', 'Mental Health Counseling', 'Music Therapist', 'Nurse', 'Occupational Therapy', 'Other Counselor (MCCM)', 'Other Therapist (MCCM)', 'Pharmacy', 'Physical Therapy', 'Sales And Marketing', 'Social Worker', 'Speech Therapy', 'Spiritual', 'Surveyor, Therapist'];
export const idgPrintConfig = {
  Measures: {
    view: 'IDG'
  },
  ClearScripts: {
    view: 'All',
    notesMode: 'dateRange'
  },
  CarePlanProblems: {
    view: 'Listing',
    notesMode: 'dateRange'
  },
  CarePlanFrequency: {
    view: 'IDG',
    notesMode: 'dateRange'
  },
  ProgressNotes: {
    view: 'IDG'
  }
}; // PECOS

export const PECOS_ELIGIBLE = 'PECOS_ELIGIBLE';
export const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']; // Visit attribute HOPE UI
// Hope Admit

export const HAD = 'HAD'; // Hope Update Visit 1

export const HUV1 = 'HUV1'; // Hope Update Visit 2

export const HUV2 = 'HUV2'; // Election Addendum Offered (system attr; not selectable in UI)

export const EAO = 'EAO'; // Election Addendum Created (system attr; not selectable in UI)

export const EAC = 'EAC'; // Forms

export const INAForm = 'Initial Nursing Assessment';
export const INAPediatricForm = 'Initial Nursing Assessment - Pediatric';
export const NVRForm = 'Nursing Visit Record';
export const NVRPediatricForm = 'Nursing Visit Record - Pediatric';
export const Completed = 'Completed'; // patient current status

export const Deceased = 'Deceased';
export const Admitted = 'Admitted';
export const PendingReferral = 'PendingReferral';
export const Referred = 'Referred';
export const Discharged = 'Discharged'; // completed-forms and forms

export const editCell = 'editCell';
export const ElectionAddendumUSFormKey = 'hz-v1-election-addendum';
export const ElectionAddendumESFormKey = 'hz-v1-es-election-addendum';
export const ElectionAddendumUSName = 'Election Addendum';
export const ElectionAddendumESName = 'Adenda de Declaración de Elegibilidad';
/** @deprecated Prefer ElectionAddendumUSName; identification should use form keys via isElectionAddendumForm */

export const ElectionAddendum = ElectionAddendumUSName;
/** @deprecated Prefer ElectionAddendumUSFormKey; use isElectionAddendumForm for US/ES */

export const ElectionAddendumFormKey = ElectionAddendumUSFormKey;
export const ElectionAddendumFormKeys = [ElectionAddendumUSFormKey, ElectionAddendumESFormKey];
export const ElectionAddendumNames = [ElectionAddendumUSName, ElectionAddendumESName];
export const HospiceElectionStatement = 'Hospice Election Statement';
export const visitHeaderID = 'visit-header-id';